<template>
    <div class="app-container">
      <BjPage
        ref="BjPage"
        :query-params="queryParams"
        :col-span="colSpan"
        :label-width="'100px'"
        :search-btn-span="colSpan"
        :get-action="queryApi"
        :serial="serial"
        :selection="selection"
        :before-reset-search="beforeResetSearch"
        :tooltip-config="{ showAll: false, enterable: false }"
        @afterFetchOriginalData="getLowTableData"
        @handleSelectionChange="handleSelectionChange"
        @showSetting="SortableTable.show"
        @header-dragend="SortableTable.handleHeaderDragend"
        @header-contextmenu="SortableTable.handleHeaderContextmenu"
      >
        <template v-slot:baseForm>
          <!-- 考核月份 -->
          <el-col :span="colSpan">
            <el-form-item :label="$t('BusinessPurchaseCostDown.Assessment')">
              <BjDateTimerangePicker v-model="queryParamsTime_month" :placeholder="$t('BusinessPurchaseCostDown.Assessment')"/>
            </el-form-item>
          </el-col>

          <!-- css空壳 -->
          <el-col :span="colSpan">
            <div style="width:30px;height: 10px;"> </div>
          </el-col>
          <el-col :span="colSpan">
            <div style="width:30px;height: 10px;"> </div>
          </el-col>
        </template>

        <template v-slot:tableOperation>
          <el-col>
            <BjFrontendExport
              type="primary"
              :label-list="labelList"
              :rows="selectedRows"
              file-name="Timeliness rate of return orders.csv"
            />
            <el-button type="primary" @click="onExportDetail">{{ $t('BusinessPurchaseCostDown.exportDetail') }}</el-button>
          </el-col>
        </template>

        <!-- 展示列表 -->
        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'"
            :key="`col_${index}_${col.prop}_${col.width || 'auto'}`"
            :prop="col.prop"
            :label="col.label"
            :width="col.width || 'auto'"
            :fixed="col.fixed || false"
            align="center"
            class-name="item"
            :show-overflow-tooltip="col.prop !== 'bjTableAction'">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'sku'">
                  <span class="link">{{ scope.row[col.prop] }}</span>
                  <BjCopyIcon :copy="scope.row[col.prop]" />
                </template>
                <template v-else-if="col.prop === 'returnTimelyRateA'">
                  <span>{{ (scope.row[col.prop]*100).toFixed(2)+'%' }}</span>
                </template>
                <template v-else-if="col.prop === 'returnTimelyRateB'">
                  <span>{{ (scope.row[col.prop]*100).toFixed(2)+'%' }}</span>
                </template>
                <template v-else-if="col.prop === 'returnTimelyRateErpA'">
                  <span>{{ (scope.row[col.prop]*100).toFixed(2)+'%' }}</span>
                </template>
                <template v-else-if="col.prop === 'returnTimelyRateErpB'">
                  <span>{{ (scope.row[col.prop]*100).toFixed(2)+'%' }}</span>
                </template>
                <template v-else-if="col.prop === 'returnTimelyRate'">
                  <span>{{ (scope.row[col.prop]*100).toFixed(2)+'%' }}</span>
                </template>
                <!-- (scope.row.levelAErpEndQty+scope.row.levelBErpEndQty) / (scope.row.levelAQty+scope.row.levelBQty) -->
                <template v-else-if="col.prop === 'TimelinessERP'">
                  <span>{{ (((scope.row.levelAErpEndQty+scope.row.levelBErpEndQty) / (scope.row.levelAQty+scope.row.levelBQty))*100).toFixed(2)+'%' }}</span>
                </template>
                <el-switch
                  v-else-if="col.prop === 'isCost'"
                  v-model="scope.row[col.prop]"
                  :active-value="true"
                  :inactive-value="false"
                  @change="switchButton($event, scope.row)"
                />
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
            </el-table-column>
          </template>
        </template>
      </BjPage>
    </div>
  </template>
  <script>
  const currentDate = new Date();
  const previousMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDate());
  import pageMiXin from '@/utils/page-mixin.js';
  import { purchaseApi } from '@/api';
  import { STATUS_YES_TRUE, PURCHASE_TYPE_NUMBER} from '@/utils/constants';
  import moment from 'moment';
  import { downloadBlob } from '@/utils/index';
  export default {
    name: 'BusinessPurchaseTimeliness',
    components: { },
    mixins: [pageMiXin],
    props: {
      businessType: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        PURCHASE_TYPE_NUMBER,
        STATUS_YES_TRUE,
        selection: true,
        colSpan: 6,
        getLowData: [],
        queryParamsTime_month: [moment(previousMonth).format('YYYY-MM-DD HH:mm:ss'), moment(currentDate).format('YYYY-MM-DD HH:mm:ss')],

        // 查询参数
        queryApi: purchaseApi.getSkuPurchaseReturnList,
        queryParams: {
          erpRequestReturnDateBegin: moment(previousMonth).format('YYYY-MM-DD HH:mm:ss'),
          erpRequestReturnDateEnd: moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
          businessType: this.businessType,
        },
        labelsVersion: 13,

        labelList: [
          { label: this.$t('BusinessPurchaseCostDown.purchaser'), prop: 'buyerName', isCheck: true, disabled: false, width: 87 },
          // { label: this.$t('BusinessPurchaseCostDown.Assessment'), prop: 'month', isCheck: true, disabled: false, width: 136 },
          { label: this.$t('BusinessPurchaseCostDown.SKUs'), prop: 'totalQty', isCheck: true, disabled: false, width: 105 },
          { label: this.$t('BusinessPurchaseCostDown.ignored'), prop: 'ignoreQty', isCheck: true, disabled: false, width: 153 },
          { label: this.$t('BusinessPurchaseCostDown.notIgnored'), prop: 'notIgnoreQty', isCheck: true, disabled: false, width: 178 },
          { label: this.$t('BusinessPurchaseCostDown.Aquantity'), prop: 'levelAQty', isCheck: true, disabled: false, width: 120 },
          { label: this.$t('BusinessPurchaseCostDown.Bquantity'), prop: 'levelBQty', isCheck: true, disabled: false, width: 120 },
          { label: this.$t('BusinessPurchaseCostDown.completedA'), prop: 'levelAEndQty', isCheck: true, disabled: false, width: 130 },
          { label: this.$t('BusinessPurchaseCostDown.completedB'), prop: 'levelBEndQty', isCheck: true, disabled: false, width: 130 },
          { label: this.$t('BusinessPurchaseCostDown.ERPA'), prop: 'levelAErpEndQty', isCheck: true, disabled: false, width: 142 },
          { label: this.$t('BusinessPurchaseCostDown.ERPB'), prop: 'levelBErpEndQty', isCheck: true, disabled: false, width: 142 },
          { label: this.$t('BusinessPurchaseCostDown.TimelinessA'), prop: 'returnTimelyRateA', isCheck: true, disabled: false, width: 176, export: { formatter: value => `${(value * 100).toFixed(2)}%` } },
          { label: this.$t('BusinessPurchaseCostDown.TimelinessB'), prop: 'returnTimelyRateB', isCheck: true, disabled: false, width: 176, export: { formatter: value => `${(value * 100).toFixed(2)}%` } },
          { label: this.$t('BusinessPurchaseCostDown.TimelinessERPA'), prop: 'returnTimelyRateErpA', isCheck: true, disabled: false, width: 176, export: { formatter: value => `${(value * 100).toFixed(2)}%` } },
          { label: this.$t('BusinessPurchaseCostDown.TimelinessERPB'), prop: 'returnTimelyRateErpB', isCheck: true, disabled: false, width: 176, export: { formatter: value => `${(value * 100).toFixed(2)}%` } },
          { label: this.$t('BusinessPurchaseCostDown.Timeliness'), prop: 'returnTimelyRate', isCheck: true, disabled: false, width: 174, export: { formatter: value => `${(value * 100).toFixed(2)}%` } },
          { label: this.$t('BusinessPurchaseCostDown.TimelinessERP'), prop: 'TimelinessERP', isCheck: true, disabled: false, width: 174, export: { formatter: (value, row) => `${(((row.levelAErpEndQty + row.levelBErpEndQty) / (row.levelAQty + row.levelBQty)) * 100).toFixed(2)}%` } },
        ]
      };
    },
    computed: {},
    watch: {
        queryParamsTime_month(v) {
            this.queryParams.erpRequestReturnDateBegin = (v || [])[0];
            this.queryParams.erpRequestReturnDateEnd = (v || [])[1];
        },
    },
    methods: {
      // 获取tableData数据
      getLowTableData(data) {
        this.getLowData = data;
      },
      // 导出详情
      onExportDetail() {
        if (!this.selectedRows.length) {
          this.$message.warning(this.$t('ThreePartySalesOrder.selectDataWarning'));
          return;
        }
        const buyerNameList = this.selectedRows.map(item => item.buyerName);
        const data = {
          buyerNameList: buyerNameList,
          erpRequestReturnDateEnd: this.queryParams.erpRequestReturnDateEnd,
          erpRequestReturnDateBegin: this.queryParams.erpRequestReturnDateBegin
        };
        purchaseApi.exportPredictionReturn(data).then(res => {
          if (!res.failed) {
            downloadBlob(res, 'Return Order Details' + new Date().toLocaleString() + '.xlsx');
          }
        });
      },

      /** 重置按钮操作 */
      beforeResetSearch() {
        this.queryParamsTime_month = [moment(previousMonth).format('YYYY-MM-DD HH:mm:ss'), moment(currentDate).format('YYYY-MM-DD HH:mm:ss')];
        return new Promise(resolve => {
          resolve();
        });
      },
    },
  };
  </script>
  <style lang="scss" scoped>
  .el-icon-s-flag {
    float: right;
    line-height: 34px;
  }
  </style>
